module.exports = __webpack_public_path__ + "static/media/kazuya.ac7b31b6.jpg";